import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import { config } from '@/config/env'

export const useSettingsStore = defineStore('settings', () => {
  const settings = ref(null)

  const isLoaded = computed(() => settings.value !== null)

  // Accès rapides aux valeurs les plus utilisées dans l'app
  const appName = computed(() => settings.value?.appName ?? 'EasyGO')
  const itemsPerPage = computed(() => settings.value?.itemsPerPage ?? 20)
  const isMaintenanceMode = computed(() => settings.value?.maintenanceMode ?? false)
  const defaultCountryId = computed(() => settings.value?.defaultCountryId ?? null)
  const footerText = computed(() => settings.value?.footerText ?? null)

  async function fetchSettings() {
    if (settings.value !== null) return  // déjà chargé, on ne re-fetch pas

    try {
      const res = await fetch(`${config.apiUrl}/settings`)
      if (res.ok) {
        settings.value = await res.json()
      }
    } catch (e) {
      console.error('Erreur chargement settings:', e.message)
    }
  }

  // Appelé par SettingsManager après un PATCH réussi pour garder le store en sync
  function updateSettings(data) {
    settings.value = { ...settings.value, ...data }
  }

  return {
    settings,
    isLoaded,
    appName,
    footerText,
    itemsPerPage,
    isMaintenanceMode,
    defaultCountryId,
    fetchSettings,
    updateSettings,
  }
})
